import React, { createContext, useContext, useState } from 'react';
import { Language, translations } from '@/lib/i18n';

type TranslationValues = typeof translations['cs'] | typeof translations['en'];

type LanguageContextType = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: TranslationValues;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<Language>('cs');
  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    // Fallback for HMR boundary issues — return defaults instead of crashing
    return { lang: 'cs' as Language, setLang: () => {}, t: translations['cs'] };
  }
  return context;
};
